/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Numero di accessi',
    BLACK_FRIDAY_COMISSION_TITLE: 'Commissioni black friday {0}',
    BLACK_FRIDAY_COMMISSION: 'Commissioni del Black Friday {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Commissioni del Black Friday {0}',
    COMISSION_DESCRIPTION: 'Totale del mese attuale',
    COMISSION_LAST_MONTH: 'Omologhi',
    COMISSION_LAST_TEN: 'Ultimi {0} giorni:',
    COMISSION_TITLE: 'Commissioni negli ultimi {0} giorni:',
    COMMISSION: 'Commissione',
    COMMISSION_COLUMN: 'Commissione (€)',
    DAILY: 'Quotidiano',
    DATE: 'Data',
    FEMALE: 'Donna',
    FIFTY_DAYS: '50 giorni',
    GENDER: 'Sesso',
    HITS: 'Visualizzazzioni negli ultimi {0} giorni:',
    HITS_DESCRIPTION: 'Visualizzazzioni',
    HOMOLOGOUS: 'Omologhi',
    HOMOLOGOUS_LAST_YEAR: 'Ultimo anno',
    MALE: 'Uomo',
    NAME: 'Nome',
    NEW_CUSTOMERS: 'Nuovi account clienti {0} giorni:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Nuovi account clienti Prozis anniversario',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Nuovi account in attesa di ordine {0} giorni:',
    NO_SALES: 'Nessuna vendita',
    ORDER_PENDING_CUSTOMERS: 'Ordine in attesa del conto',
    ORDERED_CUSTOMERS: 'Nuovo account cliente',
    ORDERS: 'Ordini negli ultimi {0} giorni:',
    ORDERS_DESCRIPTION: 'Ordini pagati negli ultimi 6 mesi',
    ORDERS_DETAIL_DESCRIPTION:
      'Ordini in attesa di pagamento negli ultimi {0} giorni:',
    ORDERS_PAY: 'Ordini pagati',
    ORDERS_PENDING: 'Ordini in sospeso',
    PERCENTAGE: 'Percentuale',
    PRODUCT_CATEGORY: 'Categoria',
    PRODUCT_COLUMN: 'Prodotto',
    QT_COLUMN: 'Quantità',
    QUANTITY: 'Quantità',
    SALES: 'Vendite',
    SALES_DESCRIPTION: 'Mese attuale',
    SALES_PRODUCT: 'Vendite per categorie di prodotti',
    TEN_DAYS: '10 giorni',
    THIRTEEN_DAYS: '30 giorni',
    TOP_COMMISSION_TITLE: 'Articoli che generano più commissioni',
    TOP_DESCRIPTION: 'Mese attuale',
    TOP_GENDER_DESCRIPTION: 'Ultimi {0} giorni',
    TOP_GENDER_TITLE: 'Più venduti per sesso',
    TOP_TITLE: 'Articoli più venduti',
    TWENTY_DAYS: '20 giorni',
    UPDATED_AT: 'Aggiornato il {0}',
    VALUE: 'Valore'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Dati mancanti',
    EMPTY_TITLE: 'Nessun dato'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
